export enum CashReceiptEnums {
    
  //Estados
  abierto = 1,
  cerrado = 2,
  anulado = 3
}